import { Link } from 'react-router-dom';
import { useAppContext } from '../../../context/AppContext';
import Modal from '../../helpers/Modal';
import {
    associatedObjectHref,
    associatedObjectKey,
    createdByLabel,
    formatAssociatedObject,
    formatTicketDateTime,
    projectPickerLabel,
    ticketResponseText,
    ticketStatusChipClass,
    ticketTitle,
    ticketTypeLabel,
} from '../../../utils/tickets';

export const TicketDetail = ({ ticket, onClose }) => {
    const { user, projects } = useAppContext();

    if (!ticket) return null;

    const project = projects.find((item) => item.id === ticket.project_id);
    const projectLabel = project
        ? projectPickerLabel(project)
        : ticket.project_id
            ? `Project #${ticket.project_id}`
            : null;

    const detail = (
        <div className="ticket-detail">
            <div className="ticket-detail__header">
                <h2 className="modal-title modal-title--flush">Ticket #{ticket.id}</h2>
                <div className="ticket-detail__badges">
                    <span className={`status-chip status-chip--sm ${ticket.ticket_type === 'support' ? 'status-chip--info' : 'status-chip--accent'}`}>
                        {ticketTypeLabel(ticket.ticket_type)}
                    </span>
                    <span className={`status-chip status-chip--sm ${ticketStatusChipClass(ticket.status)}`}>
                        {ticket.status || 'open'}
                    </span>
                </div>
            </div>

            <h3 className="ticket-detail__title">{ticketTitle(ticket)}</h3>

            <section className="ticket-detail__section">
                <h4>Description</h4>
                <p className="ticket-detail__description">{ticket.description || '—'}</p>
            </section>

            <section className="ticket-detail__section">
                <h4>Response</h4>
                {ticketResponseText(ticket) ? (
                    <p className="ticket-detail__response">{ticket.response}</p>
                ) : (
                    <p className="ticket-detail__empty">No reply yet</p>
                )}
            </section>

            <dl className="ticket-detail__meta">
                <div>
                    <dt>Project</dt>
                    <dd>
                        {ticket.project_id ? (
                            <Link to={`/project/${ticket.project_id}`}>{projectLabel}</Link>
                        ) : (
                            'None'
                        )}
                    </dd>
                </div>
                <div>
                    <dt>Related objects</dt>
                    <dd>
                        {ticket.associated_objects?.length ? (
                            <div className="ticket-object-chips">
                                {ticket.associated_objects.map((object) => {
                                    const href = associatedObjectHref(object, ticket.project_id);
                                    const label = formatAssociatedObject(object);
                                    return href ? (
                                        <Link
                                            key={associatedObjectKey(object)}
                                            to={href}
                                            className="ticket-object-chip ticket-object-chip--link"
                                        >
                                            {label}
                                        </Link>
                                    ) : (
                                        <span key={associatedObjectKey(object)} className="ticket-object-chip">
                                            {label}
                                        </span>
                                    );
                                })}
                            </div>
                        ) : (
                            'None'
                        )}
                    </dd>
                </div>
                <div>
                    <dt>Created by</dt>
                    <dd>{createdByLabel(ticket.created_by, user)}</dd>
                </div>
                <div>
                    <dt>Created</dt>
                    <dd>{formatTicketDateTime(ticket.created_at)}</dd>
                </div>
                <div>
                    <dt>Updated</dt>
                    <dd>{formatTicketDateTime(ticket.updated_at)}</dd>
                </div>
            </dl>
        </div>
    );

    return (
        <Modal
            form={detail}
            setIsModalOpen={(open) => {
                if (!open) onClose();
            }}
            isWide
            fitContent
        />
    );
};
